import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import EditTypography, { EditTypographyProps } from "@rui/EditTypography";

type ReportTitleProps = EditTypographyProps & { canEdit: boolean };

const ReportTitle = styled<React.FC<ReportTitleProps>>(
  ({ onClick, canEdit, onEditChange, value, ...props }) => {
    if (canEdit) {
      return (
        <EditTypography
          variant="h2"
          onEditChange={onEditChange}
          onClick={onClick}
          value={value}
          floatingButtons
          {...props}
        />
      );
    }

    return (
      <Typography variant="h2" noWrap {...props}>
        {value}
      </Typography>
    );
  }
)(({ theme }) => ({
  ...theme.typography.h3,
  fontWeight: 500,
  [theme.breakpoints.up("mobile")]: {
    ...theme.typography.h2,
    fontWeight: 500,
  },
  color: theme.palette.shades.neutral[800],
}));

export default ReportTitle;
